import './CheckboxOrRadioGroup-e38b5339.css';

var classes = {"Body":"prc-CheckboxOrRadioGroup-Body-cNQoa","GroupFieldset":"prc-CheckboxOrRadioGroup-GroupFieldset-0NZzG","GroupLegend":"prc-CheckboxOrRadioGroup-GroupLegend-HW4-c","CheckboxOrRadioGroupCaption":"prc-CheckboxOrRadioGroup-CheckboxOrRadioGroupCaption-9GgyY","RadioGroupLabel":"prc-CheckboxOrRadioGroup-RadioGroupLabel-anQ3U","GroupLabelChildren":"prc-CheckboxOrRadioGroup-GroupLabelChildren-j5sBI"};

export { classes as default };
